<template>
  <div class="mb-6">
    <v-dialog
      v-model="payment_annoucement"
      max-width="520"
      scrollable
      :fullscreen="$vuetify.breakpoint.xs"
      content-class="aviso-pago"
      @click:outside="closeModal()"
    >
      <v-card class="aviso-pago__tarjeta" :class="'aviso-pago__tarjeta--' + tono">
        <!-- Cabecera: el color y el icono dicen la gravedad antes de leer nada. -->
        <div class="aviso-pago__cabecera">
          <v-btn icon small dark class="aviso-pago__cerrar" aria-label="Cerrar" @click="closeModal()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span class="aviso-pago__icono"><v-icon size="30" color="white">{{ icono }}</v-icon></span>
          <h2 class="aviso-pago__titulo">{{ titulo }}</h2>
          <p class="aviso-pago__subtitulo">{{ subtitulo }}</p>
        </div>

        <v-card-text class="aviso-pago__cuerpo">
          <div v-if="cargando" class="text-center py-6">
            <v-progress-circular indeterminate :color="tono" size="32" width="3" />
          </div>

          <div v-else-if="status == 'success'" class="text-center py-2">
            <p class="aviso-pago__texto mb-2">
              Gracias por mantener sus pagos al día: su puntualidad nos permite seguir brindándole un buen servicio.
            </p>
            <p class="aviso-pago__texto mb-0">Si necesita ayuda, escríbanos desde el chat de soporte.</p>
          </div>

          <template v-else>
            <p class="aviso-pago__texto">{{ mensaje }}</p>

            <div v-if="tieneDatos" class="aviso-pago__saldo">
              <span class="aviso-pago__saldo-etiqueta">Saldo pendiente</span>
              <span class="aviso-pago__saldo-valor">{{ $filters.currency(data.total_balance) }}</span>
              <span class="aviso-pago__saldo-detalle">
                {{ data.count_invoice_pendings }} {{ Number(data.count_invoice_pendings) === 1 ? "factura pendiente" : "facturas pendientes" }}
              </span>
            </div>

            <dl v-if="tieneDatos" class="aviso-pago__datos">
              <div><dt>Plan</dt><dd>{{ $filters.name(data.product) }}</dd></div>
              <div><dt>No. contrato</dt><dd>{{ data.consecutive_contract }}</dd></div>
            </dl>

            <!-- El pago no se hace en el POS: se dice dónde, paso a paso. -->
            <section class="aviso-pago__pasos" aria-label="Cómo pagar">
              <h3>Cómo pagar</h3>
              <ol>
                <li><span>1</span><p>Ingrese a <strong>app.nubempresa.com</strong> con su usuario.</p></li>
                <li><span>2</span><p>Abra <strong>Historial de pagos</strong> y elija la factura.</p></li>
                <li><span>3</span><p>Pague. El POS vuelve a funcionar apenas se registre el pago.</p></li>
              </ol>
            </section>

            <p v-if="estado && estado.estado == 'bloqueada'" class="aviso-pago__nota">
              <v-icon x-small>mdi-information-outline</v-icon>
              Mientras tanto puede consultar, imprimir y enviar sus documentos.
            </p>
          </template>
        </v-card-text>

        <v-card-actions v-if="!cargando && status != 'success'" class="aviso-pago__acciones">
          <v-btn block depressed large :color="tono == 'error' ? 'error' : 'primary'" class="aviso-pago__pagar" @click="goToPay()">
            <v-icon left>mdi-open-in-new</v-icon>Pagar en app.nubempresa.com
          </v-btn>
          <v-btn block text small color="grey darken-1" class="aviso-pago__refrescar" @click="consultPayment()">
            <v-icon left small>mdi-reload</v-icon>Ya pagué, actualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "PaymentAnnouncement",
  data() {
    return {
      status: "no_payment",
      payment_annoucement: false,
      data: {},
      cargando: false,
      /** `estado_de_cuenta` del servidor (fase 2 del plan de contratos); null en servidores viejos. */
      estado: null,
    };
  },
  computed: {
    tieneDatos() {
      return !!this.data && this.data.consecutive_contract !== undefined && this.data.total_balance !== undefined;
    },
    // La gravedad: rojo si ya está bloqueada, amarillo si todavía puede vender (gracia o prórroga), verde al día.
    tono() {
      if (this.status == "success") return "success";
      return this.status == "pending" ? "warning" : "error";
    },
    icono() {
      return { success: "mdi-check-circle-outline", warning: "mdi-clock-alert-outline", error: "mdi-lock-alert-outline" }[this.tono];
    },
    titulo() {
      if (this.status == "success") return "Está al día";
      if (this.estado && this.estado.estado == "prorroga") return "Plazo de pago extendido";
      return this.status == "pending" ? "Tiene un pago pendiente" : "Facturación bloqueada";
    },
    subtitulo() {
      if (this.status == "success") return "No tiene pagos pendientes.";
      if (this.estado && this.estado.estado == "prorroga") return "Hasta el " + this.estado.prorroga_hasta;
      if (this.status == "pending" && this.estado && this.estado.fecha_bloqueo) {
        return "Se bloquea el " + this.estado.fecha_bloqueo + (this.estado.dias_para_bloqueo != null ? " (" + this.estado.dias_para_bloqueo + " días)" : "");
      }
      return this.status == "pending" ? "Regularice su pago para evitar el bloqueo." : "Regularice su pago para volver a vender.";
    },
    mensaje() {
      const e = this.estado;
      if (e && e.estado == "bloqueada") {
        return "Su cuenta presenta una deuda: por ahora no puede crear ni modificar facturación (vender, notas, documentos soporte).";
      }
      if (e && e.estado == "prorroga") {
        return "Su cuenta presenta una deuda con un plazo hasta el " + e.prorroga_hasta + ". Después de esa fecha no podrá crear ni modificar facturación.";
      }
      if (e && e.fecha_bloqueo) {
        return "Su cuenta presenta una deuda. Desde el " + e.fecha_bloqueo + " no podrá crear ni modificar facturación hasta regularizar su pago.";
      }
      return "Su cuenta presenta una deuda: bloquearemos algunas opciones de su servicio hasta que regularice su pago.";
    },
  },
  watch: {
    "$store.getters.payment_announcement"(val) {
      this.payment_annoucement = val;
      if (val) {
        setTimeout(() => {
          this.getInfoPending();
        }, 100);
      }
    },
  },
  mounted() {
    if (this.$store.getters.payment_announcement != null) {
      this.payment_annoucement = this.$store.getters.payment_announcement;
    }
  },
  methods: {
    consultPayment() {
      this.getInfoPending();
    },
    closeModal() {
      this.payment_annoucement = false;
      this.$store.commit("setPaymentAnnouncement", false);
      this.status = "no_payment";
    },
    goToPay() {
      // El historial de pagos es del ERP: la ruta relativa no existe en el POS (y en el escritorio abriría la caja local).
      window.open((process.env.VUE_APP_BASECONFIG_URL_ERP || "https://app.nubempresa.com") + "/business/invoice-history", "_blank");
    },
    async getInfoPending() {
      this.cargando = true;
      try {
        const res = await this.$http.get(
          "api/v1/subscription/get-info-pending-payments",
          null,
          false,
          false,
          false
        );
        if (res.success) {
          this.data = res.item;
          this.estado = (res.item && res.item.estado_de_cuenta) || null;
          if (this.data && this.data.total_balance == 0) {
            this.status = "success";
          } else if (this.estado && this.estado.estado != "bloqueada") {
            // Vencida pero todavía dentro del plazo (o con prórroga): aviso, no bloqueo.
            this.status = "pending";
          } else {
            this.status = "no_payment";
          }
        }
      } catch (e) {
        // Sin conexión no hay datos que mostrar: queda el mensaje general y el botón para pagar.
        console.log("aviso de pago: no se pudo consultar", e);
      } finally {
        this.cargando = false;
      }
    },
  },
};
</script>

<style scoped>
.aviso-pago__tarjeta { border-radius: 16px; overflow: hidden; }
.aviso-pago__cabecera {
  position: relative; padding: 28px 24px 22px; text-align: center; color: #fff;
  background: linear-gradient(135deg, var(--tono-a), var(--tono-b));
}
.aviso-pago__tarjeta--error { --tono-a: #c62828; --tono-b: #e53935; }
.aviso-pago__tarjeta--warning { --tono-a: #ef6c00; --tono-b: #fb8c00; }
.aviso-pago__tarjeta--success { --tono-a: #2e7d32; --tono-b: #43a047; }
.aviso-pago__cerrar { position: absolute; top: 8px; right: 8px; }
.aviso-pago__icono {
  display: inline-flex; align-items: center; justify-content: center; width: 56px; height: 56px;
  border-radius: 50%; background: rgba(255, 255, 255, 0.2); margin-bottom: 10px;
}
.aviso-pago__titulo { font-size: 22px; font-weight: 700; line-height: 1.2; margin: 0 0 4px; }
.aviso-pago__subtitulo { margin: 0; font-size: 14px; opacity: 0.92; }
.aviso-pago__cuerpo { padding: 20px 24px 8px !important; color: rgba(0, 0, 0, 0.8) !important; }
.aviso-pago__texto { font-size: 14px; line-height: 1.5; margin-bottom: 16px; }
.aviso-pago__saldo {
  display: flex; flex-direction: column; align-items: center; padding: 14px; border-radius: 12px;
  background: #f5f5f7; margin-bottom: 12px;
}
.aviso-pago__saldo-etiqueta { font-size: 12px; letter-spacing: 0.04em; text-transform: uppercase; color: #6b7280; }
.aviso-pago__saldo-valor { font-size: 30px; font-weight: 700; line-height: 1.2; color: var(--tono-a); }
.aviso-pago__saldo-detalle { font-size: 13px; color: #6b7280; }
.aviso-pago__datos { display: flex; gap: 12px; margin: 0 0 16px; }
.aviso-pago__datos > div { flex: 1; padding: 8px 12px; border: 1px solid #e5e7eb; border-radius: 10px; min-width: 0; }
.aviso-pago__datos dt { font-size: 11px; text-transform: uppercase; letter-spacing: 0.04em; color: #6b7280; }
.aviso-pago__datos dd { margin: 0; font-size: 14px; font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.aviso-pago__pasos h3 { font-size: 14px; margin: 0 0 8px; }
.aviso-pago__pasos ol { list-style: none; margin: 0; padding: 0; }
.aviso-pago__pasos li { display: flex; gap: 10px; align-items: flex-start; font-size: 14px; line-height: 1.4; padding: 5px 0; }
.aviso-pago__pasos li p { margin: 0; }
.aviso-pago__pasos li span {
  flex: none; width: 22px; height: 22px; border-radius: 50%; background: var(--tono-a); color: #fff;
  font-size: 12px; font-weight: 700; display: inline-flex; align-items: center; justify-content: center;
}
.aviso-pago__nota { font-size: 12.5px; color: #6b7280; margin: 12px 0 0; }
.aviso-pago__acciones { flex-direction: column; gap: 4px; padding: 12px 24px 20px !important; }
.aviso-pago__acciones > .v-btn { margin: 0 !important; }
.aviso-pago__pagar { font-weight: 600; letter-spacing: 0; text-transform: none; }
.aviso-pago__refrescar { text-transform: none; letter-spacing: 0; }
</style>
